'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { InstantSearch, Configure } from 'react-instantsearch';
import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import { ALGOLIA_INDEX_NAME, NUMBER_OF_PRODUCTS_TO_SHOW } from 'commons/constants';
import AdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/AdvancedSearchContext';
import { useTransition } from 'components/consumer/consumer-search/advanced-search-next/hooks/reactShims';
import useProductListingProductsOnDisplay from 'hooks/useProductListingData/useProductListingProductsOnDisplay';
import ShowroomDisplayContext from './hooks/ShowroomDisplayContext';
import CategoryAlgoliaLayout from './components/CategoryAlgoliaLayout';
const CategoryPageAlgolia = t0 => {
  const $ = _c(41);
  const {
    slug,
    serverCategoryData
  } = t0;
  const [currentProductIndex, setCurrentProductIndex] = useState(ALGOLIA_INDEX_NAME.PRODUCTS);
  const [isReadyToShipActive, setIsReadyToShipActive] = useState(false);
  const [minWidth, setMinWidth] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [selectedColors, setSelectedColors] = useState(t1);
  const [, startTransition] = useTransition();
  const showroomData = useProductListingProductsOnDisplay();
  let t2;
  if ($[1] !== startTransition) {
    t2 = indexName => {
      startTransition(() => {
        setCurrentProductIndex(indexName);
      });
    };
    $[1] = startTransition;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const updateCurrentProductIndex = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = checked => {
      setIsReadyToShipActive(checked);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleToggleReadyToShip = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (min, max) => {
      setMinWidth(min);
      setMaxWidth(max);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleWidthChange = t4;
  let t5;
  if ($[5] !== selectedColors) {
    t5 = colorLabel => {
      const isSelected = !!selectedColors?.[colorLabel];
      setSelectedColors(prev => ({
        ...prev,
        [colorLabel]: !isSelected
      }));
    };
    $[5] = selectedColors;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const selectColor = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setSelectedColors({});
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const clearSelectedColors = t6;
  let t7;
  if ($[8] !== currentProductIndex || $[9] !== isReadyToShipActive || $[10] !== maxWidth || $[11] !== minWidth || $[12] !== selectColor || $[13] !== selectedColors || $[14] !== updateCurrentProductIndex) {
    t7 = {
      currentSearchSection: ALGOLIA_INDEX_NAME.PRODUCTS,
      currentProductIndex,
      updateSearchSection: _temp,
      updateCurrentProductIndex,
      isReadyToShipActive,
      handleToggleReadyToShip,
      minWidth,
      maxWidth,
      handleWidthChange,
      selectedColors,
      selectColor,
      clearSelectedColors
    };
    $[8] = currentProductIndex;
    $[9] = isReadyToShipActive;
    $[10] = maxWidth;
    $[11] = minWidth;
    $[12] = selectColor;
    $[13] = selectedColors;
    $[14] = updateCurrentProductIndex;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const context = t7;
  const t8 = `categories:${slug}`;
  let filters;
  if ($[16] !== isReadyToShipActive || $[17] !== t8) {
    filters = [t8];
    if (isReadyToShipActive) {
      filters.push("is_in_stock:true");
    }
    $[16] = isReadyToShipActive;
    $[17] = t8;
    $[18] = filters;
  } else {
    filters = $[18];
  }
  const facetFilters = filters;
  let filters_0;
  if ($[19] !== maxWidth || $[20] !== minWidth) {
    filters_0 = ["item_availability=0", "visibility>1", "visibility<4"];
    const minNum = parseInt(minWidth, 10);
    const maxNum = parseInt(maxWidth, 10);
    if (!Number.isNaN(minNum) && minNum >= 1) {
      filters_0.push(`width>=${minNum}`);
    }
    if (!Number.isNaN(maxNum) && maxNum <= 300) {
      filters_0.push(`width<=${maxNum}`);
    }
    $[19] = maxWidth;
    $[20] = minWidth;
    $[21] = filters_0;
  } else {
    filters_0 = $[21];
  }
  const numericFilters = filters_0;
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      preserveSharedStateOnUnmount: true
    };
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = ["*"];
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = ["_highlightResult", "product_id", "name", "is_in_stock"];
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== facetFilters || $[26] !== numericFilters) {
    t12 = <Configure facets={t10} facetFilters={facetFilters} numericFilters={numericFilters} hitsPerPage={NUMBER_OF_PRODUCTS_TO_SHOW} attributesToRetrieve={t11} clickAnalytics={true} />;
    $[25] = facetFilters;
    $[26] = numericFilters;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== serverCategoryData || $[29] !== slug) {
    t13 = <CategoryAlgoliaLayout slug={slug} serverCategoryData={serverCategoryData} />;
    $[28] = serverCategoryData;
    $[29] = slug;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== currentProductIndex || $[32] !== t12 || $[33] !== t13) {
    t14 = <InstantSearch searchClient={searchClient} indexName={currentProductIndex} future={t9}>{t12}{t13}</InstantSearch>;
    $[31] = currentProductIndex;
    $[32] = t12;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== showroomData || $[36] !== t14) {
    t15 = <ShowroomDisplayContext.Provider value={showroomData}>{t14}</ShowroomDisplayContext.Provider>;
    $[35] = showroomData;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== context || $[39] !== t15) {
    t16 = <AdvancedSearchContext.Provider value={context}>{t15}</AdvancedSearchContext.Provider>;
    $[38] = context;
    $[39] = t15;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  return t16;
};
CategoryPageAlgolia.propTypes = {
  slug: PropTypes.string.isRequired,
  serverCategoryData: PropTypes.object
};
export default CategoryPageAlgolia;
function _temp() {}